export const membersData = [
    {
        key: "pablo-torres",
        name: "Ing. Pablo L. Torres",
        position: "Gerente General",
        avatar: "../../assets/avatar.png",
        email: "pltorres@torresyvercelli.com.ar"
    },
    {
        key: "nicolas-bolcatto",
        name: "MSc. Ing. Nicolás G. Bolcatto",
        position: "Oficina Técnica",
        avatar: "../../assets/avatar.png",
        email: "tecnica@torresyvercelli.com.ar"
    },
    {
        key: "natacha-menacho",
        name: "Ing. Natacha B. Menacho",
        position: "Oficina Técnica",
        avatar: "../../assets/avatar-fem.png",
        email: "tecnica@torresyvercelli.com.ar"
    },
    {
        key: "nahuel-ferroni",
        name: "Ing. Nahuel Ferroni",
        position: "Oficina Técnica",
        avatar: "../../assets/avatar.png",
        email: "tecnica@torresyvercelli.com.ar"
    },
    {
        key: "raul-sandoval",
        name: "Raul Sandoval",
        position: "Oficina Técnica",
        avatar: "../../assets/avatar.png",
        email: "rasandoval@torresyvercelli.com.ar"
    },
    {
        key: "nadia-de-marco",
        name: "Nadia De Marco",
        position: "Administración",
        avatar: "../../assets/avatar-fem.png",
        email: "administracion@torresyvercelli.com.ar"
    },
    {
        key: "carlos-eraso",
        name: "Carlos Eraso",
        position: "Laboratorio",
        avatar: "../../assets/avatar.png",
    },
    {
        key: "jose-druetta",
        name: "José Druetta",
        position: "Laboratorio",
        avatar: "../../assets/avatar.png"
    }
]